import Lesson from 'models/Lesson';
import React from 'react';

interface LessonContextType {
  lessons: Lesson[] | undefined;
  setRefreshData: React.Dispatch<React.SetStateAction<boolean>>;
}

export default React.createContext<LessonContextType>({
  lessons: undefined,
  setRefreshData: () => {},
});
